module.exports = __webpack_public_path__ + "img/ic_private.3e8a0e71.png";